import { Loading } from '@pages/Loading.jsx'
import { useOrgInfoStore } from '@store/common/useOrgInfoStore.js'
import { lazy } from 'react'

const SearchBarSection = lazy(() => import('@sections/home/SearchBarSection.jsx'))
const MarketTrendSection = lazy(() => import('@sections/home/MarketTrendSection.jsx'))
const AdSection = lazy(() => import('@sections/home/AdSection.jsx'))
const StockRankingSection = lazy(() => import('@sections/home/StockRankingSection.jsx'))
const ExchangeRankingSection = lazy(() => import('@sections/home/ExchangeRankingSection.jsx'))
const NewsSection = lazy(() => import('@sections/home/NewsSection.jsx'))

const KBHomePage = () => {
  const sections = useOrgInfoStore((s) => s.sections)

  if (!sections || sections.length === 0) return <Loading />

  return (
    <section>
      <MarketTrendSection />
      <SearchBarSection />

      {sections.includes('BANNER') && <AdSection />}
      {sections.includes('RANKING_ALL') && <StockRankingSection />}
      {sections.includes('RANKING_EXCHANGE') && <ExchangeRankingSection />}
      {sections.includes('NEWS') && <NewsSection />}
    </section>
  )
}

export default KBHomePage
